module.exports = __webpack_public_path__ + "media/images/qr-code-01595c242f38f9741607ac359f85575a.png";